import { prop } from 'ramda'

import type { PostExternalServiceParams, PostExternalServiceResult } from 'app/dataTypes/vending/machine/externalServices'

import type { Request } from '../../../../index'

type UrlParams = {
  machineId: number,
}

type ApiParams = {
  enable_vending_external_services: boolean
}

export const convertParams = (params: PostExternalServiceParams): [ApiParams, UrlParams] => {
  const { enableExternalServices, machineId } = params
  return [
    {
      enable_vending_external_services: enableExternalServices,
    },
    {
      machineId
    }
  ]
}

type ApiResult = {
  result: 'success'
  data: {
    enable_vending_external_services: boolean
  }
}



export const convertResult = (data: ApiResult): PostExternalServiceResult => {
  const items = prop('data', data) || {}
  const { enable_vending_external_services: enableExternalServices } = items
  return {
    enableExternalServices
  }
}

export const POST_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS: Request<PostExternalServiceParams, PostExternalServiceResult, UrlParams> = [
  'data/vending/machines/{machineId}/external_services_settings',
  'post',
  ['data'],
]
